module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.SITE_CONFIG.language_switcher === true || (_vm.$store.state.isOnSite && _vm.SITE_CONFIG.language_switcher === 'onsite')) ? _c('div', {
    staticClass: "language-switcher"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/css/flag-icon.min.css"
    }
  }), _vm._v(" "), (_vm.type === 'row') ? _c('div', {
    staticClass: "component row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "languages"
  }, _vm._l((_vm.languages), function(lang) {
    return _c('div', {
      class: {
        language: true, active: (lang.value === _vm.selectedLanguage.value || !_vm.pickedLanguage)
      },
      on: {
        "click": function($event) {
          return _vm.setLanguage(lang)
        }
      }
    }, [_c('div', {
      staticClass: "flag",
      style: ('background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + lang.flag + '.svg)')
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.type === 'dropdown') ? _c('div', {
    staticClass: "component dropdown"
  }, [(_vm.showTitle) ? _c('div', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Select your language")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "max-width"
  }, [_c('Dropdown', {
    attrs: {
      "options": _vm.languages,
      "validated": _vm.selectedLanguage && _vm.selectedLanguage.value,
      "value": _vm.selectedLanguage.value,
      "label": _vm.label,
      "with-background": true,
      "bold-label": true,
      "type": "language",
      "allow-empty": false
    },
    on: {
      "changed": _vm.changedLanguage
    }
  })], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('b', [_vm._v("Välj språk")]), _vm._v(" "), _c('span', [_vm._v("Select language")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd0e0e3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/LanguageSwitcher.vue
// module id = 1025
// module chunks = 0